'use strict';

/* Views */
import AssetBrowserComponent from './browser/asset-browser.component';
import AssetUploadComponent from './upload/asset-upload.component';
import AssetPermissionComponent from './permission/asset-permission.component';
import AssetTagsComponent from './tags/asset-tags.component';

/* Module */
export default angular.module('conduu.sm.asset', [AssetBrowserComponent, AssetUploadComponent, AssetPermissionComponent,
  AssetTagsComponent])
  .name;



// WEBPACK FOOTER //
// ./client/~sm/components/asset/index.js